import React, { type FC, VFC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { DateGuestInput } from 'components/Accommodation/DateGuestInput';
import { UnavailabilityWithChangeDates } from 'components/Unavailability/UnavailabilityComponent/UnavailabilityWithChangeDates';
import { showHotelDatePicker } from 'modules/overlay/actions';
import { DateGuestPickerSource } from 'modules/overlay/types';
import { getIsRoomsResultEmpty } from 'modules/searchApi/selectors';
import { Card } from '@daedalus/atlas/Card';
import { Divider } from '@daedalus/atlas/Divider';
import { ContentWrapper } from '@daedalus/atlas/helpers/ContentWrapper';
import { Stack } from '@daedalus/atlas/helpers/Stack';
import { Team } from '@daedalus/core/src/analytics/types/Events';
import { DatePickerType } from '@daedalus/core/src/datePicker/types';
import { RoomsSection } from '../RoomsSection/RoomsSection';
import type { ContentHotel } from '@findhotel/sapi';
interface PropsTypes {
  hotelId: ContentHotel['objectID'];
}
const _exp = /*#__PURE__*/() => Divider;
const CustomDivider = /*#__PURE__*/styled(_exp())({
  name: "CustomDivider",
  class: "c1e7tkss",
  propsAsIs: true
});
const TopRoomsSectionWrapper: FC = ({
  children
}) => <>
    <CustomDivider />
    <ContentWrapper paddingTop="s500" paddingBottom="s600">
      {children}
    </ContentWrapper>
    <Divider />
  </>;
export const TopRoomsOrUnavailability: VFC<PropsTypes> = ({
  hotelId
}) => {
  const dispatch = useDispatch();
  const unavailable = useSelector(getIsRoomsResultEmpty);
  if (unavailable) return <Stack space="s400">
        <DateGuestInput source={DateGuestPickerSource.AccommodationPageSearch} isMobile />
        <Card borderRadius="lg" borderColorPath="border.neutral.c100" dataId="soldOutWrapper">
          <ContentWrapper padding="s400">
            <UnavailabilityWithChangeDates hasCompactButton handleChangeDatesClick={() => dispatch(showHotelDatePicker(DatePickerType.CheckIn, Team.Select, DateGuestPickerSource.AccommodationPageSearch))} />
          </ContentWrapper>
        </Card>
      </Stack>;
  return <TopRoomsSectionWrapper>
      <RoomsSection hotelId={hotelId} hasPriceWatchToggle />
    </TopRoomsSectionWrapper>;
};

require("./TopRoomsOrUnavailability.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./TopRoomsOrUnavailability.tsx");